const config = {
  apiKey: "AIzaSyA7_1RvYh9_xcQef4DtzrwfmHtcQMTNcJs",
  authDomain: "test-gg-stoneoutward.firebaseapp.com",
  databaseURL: "https://test-gg-stoneoutward.firebaseio.com",
  projectId: "test-gg-stoneoutward",
  storageBucket: "test-gg-stoneoutward.appspot.com",
  messagingSenderId: "4128806734",
  appId: "1:4128806734:web:d62f38db8dcf720af7301f",
  measurementId: "G-RFCMEQVJLC"
}

export default config
